import { render, staticRenderFns } from "./ubicacionProductoEmpresa.vue?vue&type=template&id=42f287f6&scoped=true"
import script from "./ubicacionProductoEmpresa.vue?vue&type=script&lang=js"
export * from "./ubicacionProductoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ubicacionProductoEmpresa.vue?vue&type=style&index=0&id=42f287f6&prod&lang=css"
import style1 from "./ubicacionProductoEmpresa.vue?vue&type=style&index=1&id=42f287f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f287f6",
  null
  
)

export default component.exports